import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; 
import 'primereact/resources/primereact.min.css'; 
import "primereact/resources/themes/lara-light-cyan/theme.css";
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom';
import Home from './Screen/Home'
import Blogs from './Screen/Blogs'
import Blog1 from './Blogs/Blog1'
import Blog2 from './Blogs/Blog2'
import Blog3 from './Blogs/Blog3'
import Blog4 from './Blogs/Blog4'
import Blog5 from './Blogs/Blog5'
import Selectserives from './Screen/Selectserives'
import Test from './Screen/Test';
import Selectsubserives from './Screen/Selectsubserives'
import Finalform from './Screen/Finalform'
import SelectrealEaste from './Screen/SelectrealEaste'
import FinancialService from './Screen/FinancialService'
import Manufacturing from './Screen/Manufacturing'
import Automotive from './Screen/Automotive'
import Ecommers from './Screen/Ecommers'
import Appointment from '../src/Screen/Appointment'
import Thankyou from './Screen/Thankyou'
import Subscription from './Screen/Subscription'
import UsersAppointment from './Screen/UsersAppointment'
import Signup from './Screen/Signup'
import Payment from './Screen/Payment'
import Contactus from './Screen/Contactus'
import TermsandCondition from './components/TermsandCondition'
import PrivacyPolicy from './components/PrivacyPolicy'
import ReturnPolicy from './components/ReturnPolicy'
import ShippingPolicy from './components/ShippingPolicy'
import RefundandCancellationpolicy from './components/RefundandCancellationpolicy'


function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/blogs' element={<Blogs/>}/>
          <Route path='/selectservices' element={<Selectserives/>}/>
          <Route path='/selectsubserives' element={<Selectsubserives/>}/>
          <Route path='/selectrealEaste' element={<SelectrealEaste/>}/>
          <Route path='/financialService' element={<FinancialService/>}/>
          <Route path='/manufacturing' element={<Manufacturing/>}/>
          <Route path='/movers' element={<Automotive/>}/>
          <Route path='/ecommers' element={<Ecommers/>}/>
          <Route path='/finalform' element={<Finalform/>}/>
          <Route path='/appointment' element={<Appointment/>}/>
          <Route path='/thankyou' element={<Thankyou/>}/>
          <Route path='/subscription' element={<Subscription/>}/>
          <Route path='/signup' element={<Signup/>}/>
          <Route path='/payment' element={<Payment/>}/>
          <Route path='/terms-and-conditions' element={<TermsandCondition/>}/>
          <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
          <Route path='/refund-and-cancellation-policy' element={<RefundandCancellationpolicy/>}/>
          <Route path='/return-policy' element={<ReturnPolicy/>}/>
          <Route path='/shipping-policy' element={<ShippingPolicy/>}/>
          <Route path='/users-appointment' element={<UsersAppointment/>}/>
          <Route path='/contact-us' element={<Contactus/>}/>
          <Route path='/10-lean-strategies-to-boost-e-commerce-roas' element={<Blog1/>}/>
          <Route path='/from-clicks-to-visits-lean-strategies-to-convert-real-estate-leads-into-property-viewings' element={<Blog2/>}/>
          <Route path='/7-game-changing-tips-to-attract-high-quality-leads-with-meta-ads' element={<Blog3/>}/>
          <Route path='/11-proven-ways-to-attract-high-quality-leads-using-google-ads-2024' element={<Blog4/>}/>
          <Route path='/how-to-generate-leads-on-a-zero-marketing-budget-b2c-and-b2b-strategies' element={<Blog5/>}/>
          <Route path='/test' element={<Test/>}/>
          </Routes>
       </Router>

    </div>
  );
}

export default App;
